import { render, staticRenderFns } from "./LicensePlateSitecore.vue?vue&type=template&id=20644bc4"
import script from "./LicensePlateSitecore.vue?vue&type=script&lang=js"
export * from "./LicensePlateSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports